import { SettingConst } from '@faire/web-api--source/types';

/**
 * XP for testing updated homepage for EU and Canada.
 * PRD: https://www.notion.so/faire/Test-updated-Logged-out-Homepage-for-EUR-Canada-21e2efb5c25a8061b1d2ef6c5050358d
 */
export const EU_HOMEPAGE_UPDATE_XP_250910 =
  'EU_HOMEPAGE_UPDATE_XP_250910' as SettingConst<
    'EU_HOMEPAGE_UPDATE_XP_250910',
    boolean,
    'RETAILER' | 'VISITOR_WEB'
  >;
